import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { IconChevronLeft, IconChevronRight, IconDeviceFloppy } from '@tabler/icons-react';
import { TOTAL_STEPS } from '../../constants/formConstants';

const NavigationFooter = ({ 
  currentStep, 
  onPrevStep, 
  onNextStep, 
  onSubmit, 
  saving, 
  isEditing 
}) => {
  return (
    <>
      {/* Desktop Navigation Footer */}
      <div className="mpf-navigation-footer d-none d-md-flex justify-content-between align-items-center pt-4 border-top">
        <Button
          variant="outline-secondary"
          onClick={onPrevStep}
          disabled={currentStep === 1 || saving}
        >
          <IconChevronLeft size={16} className="me-1" />
          Anterior
        </Button>
        
        <div className="mpf-step-indicator">
          <span className="text-muted">Etapa {currentStep} de {TOTAL_STEPS}</span>
        </div>
        
        {currentStep < TOTAL_STEPS ? (
          <Button
            variant="primary"
            onClick={onNextStep}
            disabled={saving}
          >
            Próximo
            <IconChevronRight size={16} className="ms-1" />
          </Button>
        ) : (
          <Button
            variant="success"
            onClick={onSubmit}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner size="sm" className="me-1" />
                {isEditing ? "Atualizando..." : "Criando..."}
              </>
            ) : (
              <>
                <IconDeviceFloppy size={16} className="me-1" />
                {isEditing ? "Atualizar Publicação" : "Criar Publicação"}
              </>
            )}
          </Button>
        )}
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="mpf-mobile-navigation d-md-none">
        <div className="mpf-nav-content">
          <Button
            variant="outline-secondary"
            onClick={onPrevStep}
            disabled={currentStep === 1 || saving}
            className="mpf-nav-btn"
          >
            <IconChevronLeft size={18} />
            Anterior
          </Button>
          
          {currentStep < TOTAL_STEPS ? (
            <Button
              variant="primary"
              onClick={onNextStep}
              disabled={saving}
              className="mpf-nav-btn"
            >
              Próximo
              <IconChevronRight size={18} />
            </Button>
          ) : (
            <Button
              variant="success"
              onClick={onSubmit}
              disabled={saving}
              className="mpf-nav-btn"
            >
              {saving ? (
                <>
                  <Spinner size="sm" className="me-1" />
                  {isEditing ? "Atualizando..." : "Criando..."}
                </>
              ) : (
                <>
                  <IconDeviceFloppy size={18} />
                  {isEditing ? "Atualizar" : "Criar"}
                </>
              )}
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default NavigationFooter;